import type { ILocation } from '@/interfaces'

export class Location implements ILocation {
	branchId: number
	code: string
	name: string
	jobPrefix: string
	shortName: string
	azureOfficeAlias?: string
	fullAddress?: string
	zip?: string
	officePhone?: string
	fax?: string
	constructor({
		branchId,
		code,
		name,
		jobPrefix,
		shortName,
		azureOfficeAlias,
		fullAddress,
		zip,
		officePhone,
		fax
	}: ILocation) {
		this.branchId = branchId
		this.code = code
		this.name = name
		this.jobPrefix = jobPrefix
		this.shortName = shortName
		this.azureOfficeAlias = azureOfficeAlias
		this.fullAddress = fullAddress
		this.zip = zip
		this.officePhone = officePhone
		this.fax = fax
	}
}
